import { createContext, useContext, useState } from 'react'

const ProfileDetailContext = createContext(null)

export const ProfileDetailProvider = ({ children }) => {
    const [activeTab, setActiveTab] = useState('1')
    const onTabClicked = (tabId) => setActiveTab(tabId)

    return <ProfileDetailContext.Provider value={{ activeTab, onTabClicked }}>{children}</ProfileDetailContext.Provider>
}

export const useProfileDetail = () => useContext(ProfileDetailContext)
